<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-1" size="xl" class="country-board">
      <div class="position-relative country-board">
        <countries-board  :countries="countriesCurrent"
                          :countriesYTD="countriesYTD"
                          :countryInfos="countryInfos"
                          :helpText="getKpiToolTip(selectedKpi)"
                          :thresholds="getActiveThreshold" />
      </div>
      <template #modal-footer="{  }">
        <div style="display: none;" />
      </template>
      <template #modal-title>
        <div> 
          <span style="font-size: 1.5em; font-weight: 800;">{{ $t('Webportal.CX.CX') }}</span>
          <!-- <span style="font-size: 1.0em; line-height: 2.0em;"> {{ $t('Webportal.CX.Dashboard') }}</span> -->
          <span style="font-size: 1.0em; line-height: 2.0em;">
            {{ $t('Webportal.Map.G6B6Report') }} - {{ getKpiLabel(selectedKpi) }}
          </span>
        </div>
      </template>
    </b-modal>
    

    <!-- Dashboard Modal Box -->
    <b-modal ref="modal-2" size="xl" scrollable >
      <div class="position-relative">
        <cxDashboard  v-if="showDashboard && DashboardData"
                      :dashboardData="DashboardData"
                      :clientLocationId="RetailerSelected"
                      :defaultLogo="DefaultLogo"
                      :dealerInfo="selectedDealer"
                      :selectedTimeframe="selectedTimeframe"
                      :threshold="getActiveThreshold"
                      :relevantThresholds="relevantThresholds" />
                            <!-- :thresholdSetting="thresholdSetting"  -->
        <div v-else class="text-center spinnr">
          <b-spinner variant="primary" :label="$t('Webportal.CX.Loading')" />
        </div>
      </div>
      <template #modal-footer="{  }">
        <div style="display: none;" />
      </template>
      <template #modal-title>
        <div> 
          <span style="font-size: 1.5em; font-weight: 800;">{{ $t('Webportal.CX.CX') }}</span>
          <span style="font-size: 1.0em; line-height: 2.0em;"> {{ $t('Webportal.CX.Dashboard') }}</span>
        </div>
      </template>
    </b-modal>

    <!-- CX Table Country Modal Box -->
    <b-modal ref="modal-3" size="xl" scrollable v-on:hide="closeCountry">
      <div class="position-relative">
        <div v-if="!isLoadingCountryTable">
          <CheckBoxGrid   :customColumns="customColumns.items"
                          parentTable="markets"
                          class="mb-3"/>

          <div style="height: 78vh;">
            <CustomDataGrid :rowData="rowData"
                            :columnDefs="columnDefs"
                            :customColumns="customColumns"
                            :gridOptions="gridOptions"
                            :defaultColDef="defaultColDef"
                            :dynamicColumnDefs="dynamicColumnDefs" />
          </div>


        </div>
        <div v-else class="text-center spinnr">
          <b-spinner variant="primary" :label="$t('Webportal.CX.Loading')" />
        </div>
      </div>
      <template #modal-footer="{  }">
        <div style="display: none;" />
      </template>
      <template #modal-title>
        <div> 
          <span style="font-size: 1.5em; font-weight: 800;">{{ $t('Webportal.CX.CX') }}</span>
          <span style="font-size: 1.0em; line-height: 2.0em;"> {{ $t('Webportal.CX.Dashboard') }} Table</span>
        </div>
      </template>
    </b-modal>


    <!-- CX Table Country Modal Box -->
    <b-modal ref="modal-4" size="xl" scrollable v-on:hide="closeAllCountries">
      <div class="position-relative">
        <div v-if="true">
          <CheckBoxGrid   :customColumns="customCountryColumns.items"  
                          parentTable="retailers"
                          class="mb-3"/>

          <div style="height: 78vh;">
            <CustomDataGrid :rowData="rowDataAll"
                            :columnDefs="columnDefsCountries"
                            :customColumns="customCountryColumns"
                            :gridOptions="gridOptions"
                            :defaultColDef="defaultColDef"
                            :dynamicColumnDefs="dynamicColumnDefs" />
          </div>
        </div>
        <div v-else class="text-center spinnr">
          <b-spinner variant="primary" :label="$t('Webportal.CX.Loading')" />
        </div>
      </div>
      <template #modal-footer="{  }">
        <div style="display: none;" />
      </template>
      <template #modal-title>
        <div> 
          <span style="font-size: 1.5em; font-weight: 800;">{{ $t('Webportal.CX.CX') }}</span>
          <span style="font-size: 1.0em; line-height: 2.0em;"> NSC</span>
        </div>
      </template>
    </b-modal>


    <div ref="cockpit-and-filter" class="card map-viewer-height-full cxmap"  >
      <div  ref="cockpit"
            v-bind:class="{ spinner: isLoading, outdated: isOutdated }"
            class="card-body tab-content3"
            style="flex: 1; padding: 0rem; height: 100%;">
        <map-view-panel :countryItems="countries"
                        class="me"
                        :pointItems="dealers"
                        :kpi="selectedKpi"
                        :brandsData="brandsData"
                        :dashboardData="DashboardData"
                        :thresholdData="getActiveThreshold"
                        :selectedBrand="selectedBrand"
                        v-on:mapInitialized="mapInitialized"
                        style="flex: 1;" />
                        <!-- :thresholdSettingData="thresholdSetting" -->

      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
import CancelToken from "@/mixins/CancelToken";
import DownloadFileMixin from '@/mixins/DownloadFileMixin';
import EventBus from "@/services/EventBus.js";
import AuthenticationService from "@/services/AuthenticationService";
import DashboardService from "@/services/DashboardService-APP_TARGET";
import AdministationService from "@/services/AdministationService";
import AggregatedReportsService from "@/services/AggregatedReportsService";

import cxDashboard from "@/components/CX/Map/Dashboard-APP_TARGET";
import CountriesBoard from "@/components/CX/Map/CountriesBoard.vue";
import clientselection from "./ClientSelection";

import MapViewPanel from './Dashboard-bmw/MapViewPanel';
import CustomCxFilters from '@/mixins/bmw/custom-cx-filters.js';
import ThresholdColorMixin from '@/mixins/bmw/ThresholdColor'
import ToolTipProvider from '@/mixins/bmw/ToolTipProvider.js';

// Datagrid for Country details
import CheckBoxGrid from '@/components/CX/Grid/CheckBoxGrid';
import CustomDataGrid from '@/components/CX/Grid/CustomDataGrid';
import TableColumns from '@/mixins/bmw/CxTableColumns';

export default {
  name: "CX",

  mixins: [
    AppConfig, CancelToken, CustomCxFilters, DownloadFileMixin, 
    TableColumns, ThresholdColorMixin, ToolTipProvider
  ],

  components: {
    clientselection,
    CountriesBoard,
    cxDashboard,
    MapViewPanel,
    CheckBoxGrid,
    CustomDataGrid
  },

  watch: {
    selectedBrand: {
      handler(newVal, oldVal) {
        // EventBus.$emit('selected-brand-changed')    
      }
    }
  },

  data() {
    return {
      DefaultLogo: null,

      DashboardData: null,

      ClientSelected: null,
      CountrySelected: null,
      RetailerSelected: null,

      showCountries: true,
      showRetailer: false,
      showDashboard: false,

      isExporting: false,
      isLoadingSettings: false,
      isLoadingCountries: false,
      isLoadingKpis: false,
      isLoadingDealer: false,
      isLoadingRetailer: false,
      isLoadingBrands: false,
      isLoaded: false,

      countryCancelToken: null,
      countryInfosCancelToken: null,
      optionsCancelToken: null,
      kpiCancelToken: null,

      // tabIndex: 0,

      toolTipDelay: { delay: { show: 500, hide: 100 } },

      // The original paging is in Retailer, but it is needed to store temporarily
      pageSize: 12, // Number of items on one page of the table
      selectedPage: 1, // Number of the page, that is currently visible
      searchText: { Value: null, Changed: false },

      isOutdated: false,

      kpiData: null,
      selectedKpi: null,
      selectedBrand: "", //"bmw",
      selectedYear: '2021',
      selectedDealer: null,
      selectedTimeframe: 'current',

      marketData: {},
      countries: [],
      countriesCurrent: [],
      countriesYTD: [],
      countryInfos: [],

      dealers: [],

      // corporate Thresholds
      thresholds: [],
      
      brands: {
        selected: 'bmw',
        options: [
          { text: 'BMW', icon: 'bmw', value: 'bmw', disabled: false },
          { text: 'MINI', icon: 'mini', value: 'mini', disabled: false }
        ]
      },
      
      brandsMotorrad: {
        selected: 'bmwmotorrad',
        options: [
          { text: 'BMW Motorrad', icon: 'bmwmotorrad', value: 'bmw', disabled: false }
          // { text: 'MINI', icon: 'mini', value: 'mini', disabled: false }
        ]
      },
      dealerModal: null,

      brandItems: {},

      

      actualModal: null,
      // Dealers Modal-3
      rowData: [],
      countryTableCancelToken: null,
      isLoadingCountryTable: false,

      // All Countries Modal-4
      rowDataAll: [],
      columnDefsCountries: [
        { 
          width: 100, 
          headerName: "Details", 
          cellRenderer: 'linkCellRenderer' 
        }, { 
          width: 100, 
          headerName: "Flag", 
          field: "CountryId", 
          cellRenderer: 'flagCellRenderer', 
          autoHeight: true
        }, { 
          width: 150, 
          headerName: "Country", 
          field: "CountryName", 
          sortable: true
        }, { 
          // width: 80, 
          headerName: "Locations", 
          field: "ClientLocations", 
          sortable: true
        }
      ],
      customCountryColumns: {
        active: [],
        items: [
          // 1 Column
          { 
            group: 'Process Excellence', 
            key: 'Process Excellence',                 
            indent: 0, 
            text: 'Process Excellence', 
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, 'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Contact',  
            indent: 1, 
            text: 'Contact',
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="1. Contact")]',
            columns: this.generateColumns(1, 'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Sales Consultation',  
            indent: 1, 
            text: 'Sales Consultation',
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="2. Sales Consultation")]',
            columns: this.generateColumns(1, 'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Test Drive',  
            indent: 1, 
            text: 'Test Drive',
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="3. Test Drive")]',
            columns: this.generateColumns(1, 'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Offer',  
            indent: 1, 
            text: 'Offer',
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="4. Offer")]',
            columns: this.generateColumns(1,'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: 'Process Excellence', 
            key: 'Process Excellence.Contact Care',  
            indent: 1, 
            text: 'Contact Care',
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(1,'percent', null, 'MMMM YYYY', "Current Value", true)
          },
          { 
            group: '2', 
            key: '2',                 
            indent: 0, 
            text: 'Focus KPI', 
            isHeader: true
          }, { 
            group: '2', 
            key: '2.Process Excellence',                 
            indent: 1, 
            text: 'Process Excellence', 
            path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1,'percent', null,  'MMMM YYYY', "Current Value", true)
          }, { 
            group: '2', 
            key: '2.Lead Follow Up',                 
            indent: 1, 
            text: 'Lead Follow Up', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1,'percent', null,  'MMMM YYYY', "Current Value", true)
          },{ 
            group: '2', 
            key: '2.Appointment Follow Up',
            indent: 1, 
            text: 'Appointment Follow Up', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1,'percent', null,  'MMMM YYYY', "Current Value", true)
          },{ 
            group: '2', 
            key: '2.LMTD',
            indent: 1, 
            text: 'LM: Test Drive', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, 'percent', null,  'MMMM YYYY', "Current Value", true)
          },{ 
            group: '2', 
            key: '2.LMIO',
            indent: 1, 
            text: 'LM: Integrated Offer', 
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode==null)]',
            columns: this.generateColumns(1, 'percent', null,  'MMMM YYYY', "Current Value", true)
          },{
            group: '2', 
            key: '2.xEV Readiness',  
            indent: 1, 
            text: 'xEV Readiness',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4,'percent', null,  'MMMM YYYY', "Current Value", true)
          },{
            group: '2', 
            key: '2.My BMW App',  
            indent: 1, 
            text: 'My BMW/MINI App',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY', "Current Value", true)
          },{
            group: '2', 
            key: '2.MYSCT',  
            indent: 1, 
            text: 'MYS Customer Treatment',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, 'percent', null,  'MMMM YYYY', "Current Value", true)
          },

          // Specific Model-KPI
          { 
            group: '3', 
            key: '3',                 
            indent: 0, 
            text: 'Specific Model-KPI', 
            isHeader: true
          }, {
            group: '3', 
            key: '3.xEV Readiness',  
            indent: 1, 
            text: 'xEV Readiness',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, 'percent', null,  'MMMM YYYY', "Current Value", true)
          }, {
            group: '3', 
            key: '3.GKL+',  
            indent: 1, 
            text: 'GKL+',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4,'percent', null,  'MMMM YYYY', "Current Value", true)
          },

          // Specific Evaluations
          { 
            group: '4', 
            key: '4',
            indent: 0, 
            text: 'Specific Evaluations', 
            isHeader: true
          }, {
            group: '4', 
            key: '4.Excitement Rating',  
            indent: 1, 
            text: 'Excitement Rating',
            path: '$.Kpi[?(@.KpiGroupCode=="Excitement" && @.KpiCode==null)]',
            columns: this.generateColumns(1, 'star', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: '4', 
            key: '4.Digital Readiness',  
            indent: 1, 
            text: 'Digital Readiness',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4,'percent', null, 'MMMM YYYY', "Current Value", true)
          }, {
            group: '4', 
            key: '4.Legendary Moments',  
            indent: 1, 
            text: 'Legendary Moments',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4, 'percent', null,  'MMMM YYYY', "Current Value", true)
          }, {
            group: '4', 
            key: '4.Shops',  
            indent: 1, 
            text: '#Shops',
            // path: '$.Kpi[?(@.KpiGroupCode=="Process Excellence" && @.KpiCode=="5. Contact Care")]',
            columns: this.generateColumns(4,'percent', null, 'MMMM YYYY', "Current Value", true)
          },

          // 1 Column
          { 
            group: 'Exploration', 
            key: 'Exploration.Reviews', // Unique Key in der Liste       
            text: 'Reviews',              // Text der Checkbox / der Überschrift
            indent: 0,
            isHeader: true  // Das heißt anstatt einer Checkbox wird ein Label gerendert
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Reviews.Google',      
            text: 'Google',
            // path: '$.Explorations.Google',
            indent: 1,  
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY')   
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Reviews.Mobile',      
            indent: 1, 
            text: 'Mobile.de', 
            // path: '$.Explorations.Mobile_de',
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY')
          }, { 
            group: 'Exploration',
            key: 'Exploration.Reviews.Autoscout24',
            indent: 1,
            text: 'AutoScout 24',
            // path: '$.Explorations.Autoscout24',
            columns: this.generateColumns(4, 'star', null, 'MMMM YYYY')
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Seobility',     
            indent: 0, 
            text: 'Search Engine Optimization', 
            isHeader: true 
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Seobility_en',  
            indent: 1, 
            text: 'Seobility - Corporate Website',
            // path: '$.Explorations.Seobility',
            columns: this.generateColumns(4, 'percent', null,  'MMMM YYYY')
          }, { 
            group: 'Exploration', 
            key: 'Exploration.Seobility2_en', 
            indent: 1, 
            text: 'Seobility - Retailer Website',
            // path: '$.Explorations.Seobility2',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY')
          },

          // 2 Column
          { 
            group: 'WebPresence', 
            key: 'WebPresence',     
            indent: 0, 
            text: 'Web Presence', 
            isHeader: true 
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.Corporate',  
            indent: 1, 
            text: 'Corporate',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Web Presence - Corporate Website")].Waves',
            columns: this.generateColumns(4, 'percent', null,  'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.Retailer', 
            indent: 1, 
            text: 'Retailer',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Web Presence - Retailer Website")].Waves',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.GoogleMyBusiness',     
            indent: 0, 
            text: 'Google My Business', 
            isHeader: true 
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.GoogleMyBusiness.GoogleMyBusiness',  
            indent: 1, 
            text: 'Google My Business',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Google My Business")].Waves',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.SocialMediaPresence',     
            indent: 0, 
            text: 'Social Media Presence', 
            isHeader: true 
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.SocialMediaPresence.Facebook',  
            indent: 1, 
            text: 'Facebook',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Social Media Presence - Facebook")].Waves',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY')
          }, { 
            group: 'WebPresence', 
            key: 'WebPresence.SocialMediaPresence.Instagram', 
            indent: 1, 
            text: 'Instagram',
            // path: '$.Explorations.AFSExplorationsNEW[?(@.SurveyTitle=="Social Media Presence - Instagram")].Waves',
            columns: this.generateColumns(4, 'percent', null, 'MMMM YYYY')
          }
        ]
      }
    };
  },
  
  mounted () {
    if (!this.isMSMUser) {
      this.ClientSelected = AuthenticationService.localUserProfile.ClientId;
    }
    // console.warn("Client (mount): ", this.ClientSelected)
    // this.getClientSettings();

    // EventBus.$on("LocalizationChanged", this.reloadCurrentTab);
    EventBus.$on("client-selection-changed", this.onClientSelectionChanged);
    EventBus.$on("Score_Changed", (selectedScoreId) => {
      this.getDealer(selectedScoreId);
    })
    EventBus.$on("mapDealerClicked", this.showDealer);
    EventBus.$on("map-country-clicked", this.showCountryTable);
    EventBus.$on("show-market-details-clicked", this.showCountryTableFromNsc);
    EventBus.$on("show-retailer-details-clicked", this.showDealerFromCountry);


    EventBus.$on("countries-grid-show", this.showAllCountriesTable);
    EventBus.$on("selected-kpi-changed", (x) => {
      this.selectedKpi = x;
      let th = this.getActiveThreshold;
      EventBus.$emit("active-threshold-data", th);
      this.getCountries('kpi', this.selectedKpi);
    });
    EventBus.$on("selected-brand-changed", (x) => {
      if (!x) {
        return;
      }
      this.selectedBrand = x;
      this.initTooltips(this.selectedBrand);
      this.getCountries('brand', this.selectedBrand);
    });
    EventBus.$on("selected-brand-switched", (x) => {
      this.initTooltips(this.selectedBrand);
    });

    EventBus.$on("selected-performance-index-changed", (x) => {
      this.selectedPerformanceIndex = x;
      // EventBus.$emit("active-threshold-data", this.getActiveThreshold);
    });
    EventBus.$on("selected-year-changed", (x) => {
      if (!x) {
        return;
      }
      this.selectedYear = x;
      this.getCountries('year', this.selectedYear);
    });
    EventBus.$on("show-dealers-changed", (x) => {
      this.getCountries();
      EventBus.$emit("show-dealers-changed2", x);
    });
    
    EventBus.$on("selected-time-setting-changed", (x) => {
      this.selectedTimeframe = x;
      this.getCountries();
    });
    EventBus.$on("show-g6b6-countries", () => {
      this.initTooltips(this.selectedBrand);
      // let aa = _.isArray(this.countries);
      // let bb = _.isEmpty(this.countries);
      // if (Array.isArray(this.countries) && this.countries.length && Array.isArray(this.countriesYTD) && this.countries.countriesYTD) {
        this.$refs['modal-1'].show();
      // }
    });
    EventBus.$on("grid-selected-custom-columns-changed", this.selectedCustomColumns);

  },

  beforeDestroy() {
    // EventBus.$off("LocalizationChanged", this.reloadCurrentTab);
    EventBus.$off("client-selection-changed", this.onClientSelectionChanged);
    EventBus.$off("Score_Changed");
    EventBus.$off("mapDealerClicked", this.showDealer);

    EventBus.$off('map-country-clicked', this.showCountryTable);
    EventBus.$off("show-market-details-clicked", this.showCountryTableFromNsc);
    EventBus.$off("show-retailer-details-clicked", this.showDealerFromCountry);

    EventBus.$off("selected-kpi-changed");
    EventBus.$off("selected-brand-changed");
    EventBus.$off("selected-brand-switched");
    EventBus.$off("selected-performance-index-changed");
    EventBus.$off("selected-time-setting-changed");
    EventBus.$off("selected-year-changed");
    EventBus.$off("show-dealers-changed");
    EventBus.$off("show-g6b6-countries");
    EventBus.$off("grid-selected-custom-columns-changed", this.selectedCustomColumns);
    EventBus.$off("countries-grid-show", this.showAllCountriesTable);
  },

  methods: {
    getKpiToolTip(kpi) {
      return !kpi ? null : this.getKpiLongtextToolTip(kpi.id);
    },

    getKpiLabel(kpi) {
      return !kpi ? null : kpi.label;
    },

    getCountryInfos() {
      if (!this.ClientSelected) return;

      const countryInfosCancelToken = this.initCancelToken(this.countryInfosCancelToken);

      return DashboardService.getClientLocationCountries(
          this.ClientSelected || AuthenticationService.localUserProfile.ClientId,
          countryInfosCancelToken
        )
        .then(response => {
          this.countryInfos = response.data;
        })
        .catch(error => console.error(error))
        .finally(() => {});
    },

    selectedCustomColumns(params) {
      switch(this.actualModal) {
        case 'modal-3':
          if (this.customColumns && this.customColumns.active)
          this.customColumns.active = params;
          console.log('Single', this.customColumns.active)
          break;

        case 'modal-4':
          if (this.customCountryColumns && this.customCountryColumns.active)
          this.customCountryColumns.active = params;
          console.log('Country', this.customCountryColumns.active)
          break;
      }
    },

    getRandomInt(min, max){
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min; 
    },
    closeAllCountries(event) {
      this.customCountryColumns.active = [];
      this.actualModal = null;
      this.rowDataAll = [];
    },
    closeCountry(event) {
      this.customColumns.active = [];
      this.actualModal = null;
      this.rowData = [];
    },
    showAllCountriesTable() {
      let row = [...this.countryInfos];
      row.forEach(x => {
        x.Kpi = [...this.marketData.Market.filter(y => x.CountryId == y.CountryId)];
      });
      this.rowDataAll = row.filter(x => x.Kpi.length > 0);
      this.actualModal = 'modal-4';
      this.$refs['modal-4'].show();
    },

    showCountryTableFromNsc(countryCode) {
      this.closeAllCountries(null);
      this.$refs['modal-4'].hide();
      this.showCountryTable(countryCode);
    },

    showDealerFromCountry(locationId) {

    },

    showCountryTable(countryCode) {
      this.CountrySelected = countryCode;
      if (this.CountrySelected == null) return;
      this.isLoadingCountryTable = true;
      this.countryTableCancelToken = this.initCancelToken(this.countryTableCancelToken);
      
      this.actualModal = 'modal-3';
      this.$refs['modal-3'].show();
      return DashboardService.getCXDealers(
        { ClientId: this.ClientSelected, CountryId: this.CountrySelected },
        { searchText: '', page: this.selectedPage, pageSize: 1000 //this.pageSize
        },
        this.countryTableCancelToken
      )
      .then(response => {
        let locations = [];
        if (this.brandsData.selected === 'MINI') {
          locations = [...response.data?.AggregatedData.filter(x => x.CustomLocationId.endsWith('MI'))];
        } else {
          locations = [...response.data?.AggregatedData.filter(x => x.CustomLocationId.length === 8)];
        }
        
        const kpis = [ 'Follow-up', 'Customer Treatment', 'Responsetime', 'Measures'  ]

        for (let i = 0; i < locations.length; i++) {
          const el = locations[i];
          el.FocusKPI = [];

          for (let j = 0; j < 4; j++) {
            const kpi = this.fakeKpi(j, kpis[j], j % 2 == 0);
            el.FocusKPI.push(kpi);
          };

        };

        this.rowData = locations;
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        this.isLoadingCountryTable = false;
      });
    },

    fakeKpi(index, name, percent = true){
      let kpi = {
        KpiCode: name,
        KpiName: name,
        KpiNameShort: name,
        KpiGroupCode: "Group1",
        SurveyWave: [
          {
            Name: "Q2 2022",
            Year: 2022,
            Result: this.getRandomInt(1, percent ? 100 : 5)
          },
          {
            Name: "Q1 2022",
            Year: 2022,
            Result: this.getRandomInt(1, percent ? 100 : 5)
          },
          {
            Name: "Q4 2021",
            Year: 2021,
            Result: this.getRandomInt(1, percent ? 100 : 5)
          },
          {
            Name: "Q3 2021",
            Year: 2021,
            Result: this.getRandomInt(1, percent ? 100 : 5)
          }
        ],
        YTD: [
          {
            Year: 2022,
            Result: 90,
            PointsReached: 2,
            PointsMax: 2
          }
        ]
      };
      return kpi;
    },

    showDealer(dealer) {
      this.$refs['modal-2'].show();
      this.selectedDealer = dealer;
      this.showDashboard = true;
      this.RetailerSelected = dealer.LocationId;
      this.CountrySelected = dealer.CountryId;
      document.activeElement.blur();
      return this.getDealer(-1);
    },

    excelExport() {
      // Workaround: The tooltip doesn't hide as the button is disabled and disabled elements
      // can't be (un)focused - parent elements are a bit iffy in this specific case
      // this.$root.$emit('bv::hide::tooltip', 'excelButton')

      this.isExporting = true;
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      // Filter depends on selected tab
      const filter = {
        clientId:  this.ClientSelected
        // countries: (this.tabIndex >= 2) ? this.CountrySelected : null,
        // locations: (this.tabIndex >= 3) ? this.RetailerSelected : null
      };

      // Set spinning cursor
      document.body.style.cursor = "progress";

      AggregatedReportsService.getCXReport(filter, this.optionsCancelToken)
        .then(response => this.downloadFile(response))
        .catch(error => console.error(error))
        .finally(() => {
          this.isExporting = false;
          document.body.style.cursor = null;
        });
    },

    async reloadCurrentTab(localizationId) {
      await this.initBrands();
      await this.getKpis();
      await this.getCountries();
    },

    getActiveCountries(kpiInfos, timeFrame) {
      let time = timeFrame ? timeFrame : kpiInfos.TimeFrame;
      let market = time == 'current' 
        ? this.marketData.Market
        : this.marketData.MarketYTD

      if(!market) {
        return [];
      }
      
      return kpiInfos.IsGroup
        ? market.filter(x => x.KpiCode == null && x.KpiGroupCode == kpiInfos.Code)
        : market.filter(x => x.KpiCode == kpiInfos.Code && x.KpiGroupCode == kpiInfos.Group);
    },

    getActiveDealers(kpiInfos) {
      let retailers = kpiInfos.TimeFrame == 'current' 
        ? this.marketData.Retailer
        : this.marketData.RetailerYTD

      return _.chain(retailers || [])
        .groupBy('pos')
        .map((value, key) => {
          return {
            Address: value[0].Address,
            City: value[0].City,
            CountryId: value[0].CountryId,
            CountryName: value[0].CountryName,
            CustomLocationId: value[0].CustomLocationId,
            // KpiPointsMax: value[0].KpiPointsMax,
            // KpiPointsReached: value[0].KpiPointsReached,
            LocationId: value[0].LocationId,
            LocationName: value[0].LocationName,
            lat: value[0].lat,
            lng: value[0].lng,
            param: _.map(value, o => _.omit(o, 'pos')) //do not include the index key from the previous objects
          }
        }).value();
    },

    getCountries(reason, value) {
      if (this.isLoadingCountries || this.ClientSelected == null || this.selectedKpi == null || this.selectedBrand == null || !this.brandItems.ready) {
        return;
      }
      
      let kpiInfos = {
        Code:  this.selectedKpi.id.startsWith("GRP_") ? this.selectedKpi.id.replace("GRP_", "") : this.selectedKpi.id,
        IsGroup: this.selectedKpi.id.startsWith("GRP_") ? 1 : 0,
        Group: this.selectedKpi.KpiGroupName,
        TimeFrame: this.selectedTimeframe
      };

      if (reason !== 'brand' && reason !== 'year' && this.marketData.Market && this.marketData.Market.length > 0) {
        this.countries = this.getActiveCountries(kpiInfos);
        this.countriesCurrent = this.getActiveCountries(kpiInfos, 'current');
        this.countriesYTD = this.getActiveCountries(kpiInfos, 'ytd');
        return;
      }

      this.isLoadingCountries = true;
      this.countryCancelToken = this.initCancelToken(this.countryCancelToken);

      let options = {
        ClientId: this.ClientSelected,
        Year: this.selectedYear,
        Brand: this.brandItems[this.selectedBrand]
      };

      this.getCountryInfos();

      return DashboardService.getCXMarket(
          options,
          null,
          this.countryCancelToken
        )
        .then(response => {
          // If no data show nothing
          if (response?.data?.AggregatedData?.length <= 0)
            return;
        
          if (response?.data?.Retailer) {
            response.data.Retailer.forEach(d => { d.pos = `${d.lat}_${d.lng}`});
          }         
          if (response?.data?.RetailerYTD) {
            response.data.RetailerYTD.forEach(d => { d.pos = `${d.lat}_${d.lng}`});
          }
         
          // Save list of all country/Kpi pairs
          this.marketData =  {
            Market: (response?.data?.MarketKPI || []).concat(response?.data?.MarketKPIGroup || []),
            MarketYTD: (response?.data?.MarketKPIYTD || []).concat(response?.data?.MarketKPIGroupYTD || []),
            Retailer: response?.data?.Retailer || [],
            RetailerYTD: response?.data?.RetailerYTD || [],
          } || { Market: [], MarketYTD: [], Retailer: [], RetailerYTD: [] };
        
          // select all countries with actually selected KPI           
          this.countries = this.getActiveCountries(kpiInfos);

          // Used inCountriesboard
          this.countriesCurrent = this.getActiveCountries(kpiInfos, 'current');
          this.countriesYTD = this.getActiveCountries(kpiInfos, 'ytd');
          this.dealers = this.getActiveDealers(kpiInfos);

          let items = [];
          for (let [i, item]  of this.kpiData.items.entries()) {
            let isGroup = item.id.startsWith("GRP_");

            let aMarketItem = isGroup 
              ? this.marketData.MarketYTD.find(x => x.KpiGroupCode == item.KpiGroupName)
              : this.marketData.MarketYTD.find(x => x.KpiCode == item.id);
            item.isDisabled = aMarketItem === undefined;

            if (!item.isDisabled) {
              if (item.children !== undefined) {
                for (let [j, child]  of item.children.entries()) {
                  let kpiHasData = this.marketData.MarketYTD.find(x => x.KpiCode == child.id);
                  child.isDisabled = kpiHasData === undefined;
                }
              }
            }
            items.push(item);
          }

          EventBus.$emit("kpi-data",  { selected: this.selectedKpi, items: JSON.parse(JSON.stringify(this.kpiData.items)) });
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isLoadingCountries = false;
        });
    },

    getKpis() {
      if (this.ClientSelected == null)
        return;
      
      this.isLoadingKpis = true;
      this.kpiCancelToken = this.initCancelToken(this.kpiCancelToken);

      return DashboardService.getCXKpi(
          { 'client-id': this.ClientSelected }, null, this.kpiCancelToken)
        .then(response => {
          this.kpiData = this.getFilteredCxKpi(response.data.KPIGroups);
          EventBus.$emit("kpi-data", this.kpiData);
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.isLoadingKpis = false;
        });
    },

    getDealer(scoreId) {
      if (this.RetailerSelected == null || this.CountrySelected == null || this.ClientSelected == null) {
        return Promise.resolve();
      }

      this.isLoadingDealer = true;
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);
      this.DashboardData = null;

      let selectedDealer = this.dealers.find(x => x.LocationId == this.RetailerSelected);
      let options =  {
        scoreId: scoreId,
        year: this.selectedYear,
        LocationIds: selectedDealer.param.map(x => x.LocationId).join(',')
      };

      return DashboardService.getDealer(options, this.optionsCancelToken)
        .then(response => {
          this.DashboardData = null;
          if (response.data) {
            let res = response.data;
            if (!res.KPI) res.KPI = [];
            if (!res.KPI.KPI) res.KPI.KPI = [];
            if (!res.KPI.KPIGroup) res.KPI.KPIGroup = [];
            if (!res.KPI.KPIYTD) res.KPI.KPIYTD = [];
            if (!res.KPI.KPIGroupYTD) res.KPI.KPIGroupYTD = [];
            this.DashboardData = response.data;
          }
        })
        .finally(() => {
          this.isLoadingDealer = false;
        });
    },

    initBrands() {
      this.isLoadingBrands = true;
      return DashboardService.getOptions({ api: '2021' })
        .then(res => {
          this.brandItems = this.getBmwBrandItems(res.data[0].Brand);
        }).finally(x => { this.isLoadingBrands = false; });
    },

    getBrand(clientSettings) {
      return clientSettings?.ClientName?.startsWith("BMW Motorrad") 
            ? 'bmwmotorrad'
            : 'bmw';
    },

    // ***********************************************************
    // HTML Events
    // ***********************************************************

    // Client Selection (for MSMUser)
    // ******************************
    onClientSelectionChanged(clientSettings) {
      if (!clientSettings) {
        return;
      }
      if (this.ClientSelected == clientSettings.ClientId && this.isLoaded) {
        return;
      } 
    

      this.ClientSelected = clientSettings?.ClientId || null;
      this.selectedBrand = clientSettings?.ClientName?.startsWith("BMW Motorrad") 
        ? 'bmwmotorrad'
        : 'bmw';

      this.isLoaded = true;
      this.showRetailer = false;
      this.showDashboard = false;
      this.showCountries = true;
      this.DashboardData = null;
      this.marketData = {};

      EventBus.$emit("selected-brand-switched", this.selectedBrand);
      this.setClientSettings(clientSettings);
      EventBus.$emit("active-threshold-data", this.thresholds);

      this.reloadCurrentTab();
    },

    // ***********************************************************
    // Private methods
    // ***********************************************************
    getClientSettings(clientId) {
      return AdministationService.getClientSettings(clientId || this.ClientSelected)
        .then(response => {
          this.setClientSettings(response?.data?.[0]);
        });
    },

    setClientSettings(clientSettings) {
      if (!clientSettings) 
        return;
      this.thresholds = clientSettings.Thresholds;
      this.DefaultLogo = clientSettings.LogoExternalImageId
        ? process.env.BASE_URL + `api/media/image?id=${clientSettings.LogoExternalImageId}`
        : process.env.BASE_URL + "static/img/msm_loop_logo_40px.png";
    },

    mapInitialized(e) {
    }
  },

  computed: {
    isMSMUser: function() {
      return AuthenticationService.isMSMUser;
    },

    isLoading: function() {
      return (
        this.isLoadingSettings ||
        this.isLoadingCountries ||
        this.isLoadingKpis ||
        this.isLoadingDealer ||
        this.isLoadingRetailer ||
        this.isLoadingBrands
      );
    },

    brandsData: function()  {
      return this.selectedBrand === 'bmwmotorrad'
        ? this.brandsMotorrad
        : this.brands;
    },

    // getThresholds() {
    //   return this.thresholds || this.defaultThreshold();
    // },
    
    getActiveThreshold() {
      let th = this.selectedKpi ? this.getNamedThreshold(this.selectedKpi.th) ?? this.thresholds : this.defaultThreshold();
      for (let [i, tt] of th.entries()) {
        if (this.thresholds[i]) {
          tt.Color = this.thresholds[i].Color;
        }
      }

      return th || this.defaultThreshold();
    },

    relevantThresholds() {
      let items = this.getRelevantThresholds();
      items[0].threshold = this.thresholds;

      for (let [j, tItem] of items.entries()) {
        if (j === 0) continue;
        for (let [i, tt] of tItem.threshold.entries()) {
          if (items[0] && items[0].threshold[i]) {
            tt.Color = items[0].threshold[i].Color;
          }
        }
      }

      return items;
    },

    dynamicColumnDefs() {
      let items = [];
      switch(this.actualModal) {
        case 'modal-3':
          items = [...this.columnDefs];
          items.push(...this.customColumns.active.map(x => { return this.mixinGetColumn(x) } ));
          break;
        case 'modal-4':
          items = [...this.columnDefsCountries];
          items.push(...this.customCountryColumns.active.map(x => { return this.mixinGetColumn(x, this.customCountryColumns) } ));
          break;
      }
      return items;
    }
  }
};
</script>

<style lang="scss" >
.cx-size {
  min-height: 400px !important;
}

.modal-xl {
  max-width: 98%!important;
  height: calc(100vh - 1rem)!important;
  width: calc(100vw - 2rem)!important;
}

.modal-dialog-scrollable, .modal-content {
  max-height: calc(100vh - 1rem);
}


</style>

<style lang="scss" scoped>
.modal-dialog {
  margin: 1rem!important;
}

.modal-header {
  padding: 1rem 1rem 0.5rem 1rem;
}

.modal-open .modal {
  padding-left: 0px !important;
}
.spinnr {
  margin-top: 20vh;
  margin-bottom: 20vh;
}

.country-board > .modal-content {
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 1680px !important;
} 

.spinner::after {
  top: 40vh !important;
}

.cxmap {
  border: 0px !important;
  top: -16px;
  margin: 0px !important;
  padding: 0px !important;
}

.cs-overlay {
  z-index: 1;
  float: right;
  position: relative;
  bottom: -116px;
  width: 52%;
  /* left: 55%; */
  margin-bottom: -36px;
}

ul#brandicons  {
  margin: 0;
  padding: 0px 0px 0px 0px;
  list-style: none;
  line-height: normal;
}
li#brandicons  {
  display: inline;
  list-style-type: none;
}

#brandicons, a {
  letter-spacing: 1px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 300;
}

html, body {
  height: 100%;
}

#footer {
  bottom: 0 !important;
  position: fixed !important;
}

.emptyplacehold{
  width: 100%;
  height: 200%;
  text-align: center;
  margin-top: 27em;
}

.container {
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  width: 100%;
}

.card {
  /* margin-bottom: 20px; */
  word-wrap: unset;
}

.card-body {
  min-height: 150px;
}

.excelButton {
  background-color: #107c41;
  border-color: #107c41;
}

.excelButtonTooltip {
  z-index: 1;
  float: right;
  position: relative;
  bottom: -10px;
  right: 3px;
  margin-bottom: -50px;
}

.tooltip {
  /* Workaround: https://github.com/bootstrap-vue/bootstrap-vue/issues/1732 */
  top: 0;
}
</style>

<style>
.tab-map-height {
  height: 100%;
}

.disabledTab {
  pointer-events: none;
}

.disabledTab > .nav-link {
  pointer-events: none;
  display: none;
  color: rgba(255, 255, 255, 0) !important;
  cursor: not-allowed;
}
</style>
